import Navigation from "../../../../components/header";
import { Container } from "@mui/material";

const MonthlyWeightSummaryReport = () => {
	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<h1 className="report-header">Monthly Weight Summary Report</h1>
				<iframe title="HWIOnline_MonthlyWeightSummary_DEV" width="1140" height="700" src="https://app.powerbi.com/reportEmbed?reportId=5c78a386-bba4-485a-8b2e-c3ed83493482&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2" frameBorder="1"></iframe>
			</Container>

		</>
	);
};

export default MonthlyWeightSummaryReport;